import React from 'react';
import Hero from './components/Hero';

function App() {
  return (
    <div className="bg-white text-black min-h-screen">
      <main>
        <Hero />
      </main>
    </div>
  );
}

export default App;